import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import KpiLastProcessed from './kpi-last-processed';
import KpiLastProcessedDetail from './kpi-last-processed-detail';
import KpiLastProcessedUpdate from './kpi-last-processed-update';
import KpiLastProcessedDeleteDialog from './kpi-last-processed-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={KpiLastProcessedUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={KpiLastProcessedUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={KpiLastProcessedDetail} />
      <ErrorBoundaryRoute path={match.url} component={KpiLastProcessed} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={KpiLastProcessedDeleteDialog} />
  </>
);

export default Routes;
